import { Toaster } from "react-hot-toast";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./App.css";
import RoutesList from "./routes";

// Create a client with custom configuration to prevent unnecessary refetches
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Disable refetch on window focus to prevent repeated API calls
      refetchOnWindowFocus: false,
      // Disable refetch on reconnect
      refetchOnReconnect: false,
      // Set stale time to 5 minutes to prevent frequent refetches
      staleTime: 5 * 60 * 1000,
      // Set cache time to 10 minutes
      gcTime: 10 * 60 * 1000,
      // Retry only once on failure
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster />
      <div className="font-inter flex flex-col">
        <RoutesList />
      </div>
    </QueryClientProvider>
  );
}

export default App;
